import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_board = `${hostApi}/api/app/boards`

function getBoardList(params) {
    return Vue.prototype.$http.get(api_board, { params });
}

function getBoard(id) {
    return Vue.prototype.$http.get(`${api_board}/${id}`);
}

export {
    getBoardList,
    getBoard,
};
